import React from 'react';
import { Spin } from 'antd';

interface PageLoaderInterface {

}

const PageLoader: React.FC<PageLoaderInterface> = () => {
  return (
    <div className="page-loader">
      <Spin size="large" />
    </div>
  )
}

export default PageLoader;
